module.exports = __webpack_public_path__ + "img/icon_map_10_on_101.c1cf7629.png";